import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';

const Footer: React.FC = () => {
    return (
        <footer className="app-footer">
            <span>Website developed by Tigran Gavaryan</span>
            <ul className="social">
                <a
                    href="https://www.linkedin.com/in/tigran-gavaryan-37b82b121"
                    target="_blank"
                    rel="noopener noreferrer">
                    <li className="social-li facebookAndLinkedIn">
                        <FontAwesomeIcon
                            width="15"
                            height="15"
                            color="white"
                            icon={faLinkedinIn} />
                    </li>
                </a>
            </ul>
        </footer>
    )
}

export default Footer;